// Extracts dynamic route parameter names from pathname (e.g., [projectId] -> projectId)
export const getDynamicRouteParams = (pathname: string): string[] => {
  const matches = pathname.match(/\[([^\]]+)\]/g) || [];
  return matches.map((match) => match.slice(1, -1));
};

// Filters out dynamic route parameters from query object to avoid duplicating them as query params
export const filterDynamicRouteParams = <T extends Record<string, unknown>>(
  query: T,
  pathname: string,
): Record<string, unknown> => {
  const dynamicParams = getDynamicRouteParams(pathname);
  return Object.fromEntries(Object.entries(query).filter(([key]) => !dynamicParams.includes(key)));
};
